import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5b7a2b3e"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "overlay overlay_z" }, null, -1));
const _hoisted_2 = { class: "content" };
const _hoisted_3 = { class: "main_title" };
const _hoisted_4 = { class: "main_box" };
const _hoisted_5 = { class: "input_group" };
const _hoisted_6 = {
    class: "input_group",
    style: { "margin-top": "20px" }
};
const _hoisted_7 = {
    class: "input_group",
    style: { "margin-top": "20px" }
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = { class: "button_box" };
import { ref } from 'vue';
import { useClipboard } from '@vueuse/core';
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
import TextWithLabel from '@/materials/molecules/TextWithLabel.vue';
import { useMessage } from '@/const/messages';
export default /*#__PURE__*/ _defineComponent({
    props: {
        apiAccessToken: null
    },
    emits: ["close"],
    setup(__props, { emit }) {
        const props = __props;
        const INPUT_ACCESS_KEY = 'access_key';
        const INPUT_ACCESS_SECRET = 'access_secret';
        const copyItem = ref(INPUT_ACCESS_KEY);
        const { MYPAGE_API_MANAGEMENT, format } = useMessage();
        const { copy, copied, isSupported } = useClipboard({ legacy: true });
        const onClose = () => emit('close');
        const onCopy = (item, source) => {
            copyItem.value = item;
            copy(source);
        };
        const onDownloadCsv = () => {
            let csvContent = `data:text/csv;charset=utf-8,${props.apiAccessToken.label},${props.apiAccessToken.plain_access_key},${props.apiAccessToken.plain_access_secret}`;
            const encodedUri = encodeURI(csvContent);
            const link = document.createElement('a');
            link.setAttribute('href', encodedUri);
            link.setAttribute('download', 'access_token.csv');
            document.body.appendChild(link);
            link.click();
        };
        return (_ctx, _cache) => {
            var _a, _b, _c;
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _hoisted_1,
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("label", null, _toDisplayString(_unref(format)(_unref(MYPAGE_API_MANAGEMENT).TITLE_API_ACCESS_TOKEN_RESULT)), 1),
                        _createVNode(MaterialIcon, {
                            name: "close",
                            class: "close_button",
                            onClick: onClose
                        })
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(TextWithLabel, {
                                label: _unref(format)(_unref(MYPAGE_API_MANAGEMENT).INPUT_LABEL_LABEL_NAME),
                                "default-value": (_a = props.apiAccessToken) === null || _a === void 0 ? void 0 : _a.label,
                                readonly: ""
                            }, null, 8, ["label", "default-value"])
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(TextWithLabel, {
                                label: _unref(format)(_unref(MYPAGE_API_MANAGEMENT).INPUT_LABEL_ACCESS_KEY),
                                "default-value": (_b = props.apiAccessToken) === null || _b === void 0 ? void 0 : _b.plain_access_key,
                                readonly: ""
                            }, null, 8, ["label", "default-value"]),
                            (_unref(isSupported))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: "#",
                                    class: "link",
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => { var _a, _b; return (onCopy(INPUT_ACCESS_KEY, (_b = (_a = props.apiAccessToken) === null || _a === void 0 ? void 0 : _a.plain_access_key) !== null && _b !== void 0 ? _b : '')); }, ["prevent"]))
                                }, _toDisplayString(copyItem.value === INPUT_ACCESS_KEY && _unref(copied) ? 'Copied!' : 'Copy'), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(TextWithLabel, {
                                label: _unref(format)(_unref(MYPAGE_API_MANAGEMENT).INPUT_LABEL_ACCESS_SECRET),
                                "default-value": (_c = props.apiAccessToken) === null || _c === void 0 ? void 0 : _c.plain_access_secret,
                                readonly: ""
                            }, null, 8, ["label", "default-value"]),
                            (_unref(isSupported))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: "#",
                                    class: "link",
                                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => { var _a, _b; return (onCopy(INPUT_ACCESS_SECRET, (_b = (_a = props.apiAccessToken) === null || _a === void 0 ? void 0 : _a.plain_access_secret) !== null && _b !== void 0 ? _b : '')); }, ["prevent"]))
                                }, _toDisplayString(copyItem.value === INPUT_ACCESS_SECRET && _unref(copied) ? 'Copied!' : 'Copy'), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("a", {
                            href: "#",
                            class: "link",
                            style: { "margin-top": "20px" },
                            onClick: _withModifiers(onDownloadCsv, ["prevent"])
                        }, [
                            _createVNode(MaterialIcon, { name: "download" }),
                            _createTextVNode(" " + _toDisplayString(_unref(format)(_unref(MYPAGE_API_MANAGEMENT).LINK_DOWNLOAD)), 1)
                        ], 8, _hoisted_8)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", {
                            onClick: onClose,
                            class: "act-btn"
                        }, _toDisplayString(_unref(format)(_unref(MYPAGE_API_MANAGEMENT).BTN_CLOSE)), 1)
                    ])
                ])
            ], 64));
        };
    }
});
